/**
 * Created by dvircohen on 21/03/2017.
 */
(function () {
    'use strict';

    // @ngInject
    function WorkflowManagerCtor($q, APIService, ModelFactory, _, Routes) {
        this.constructor.$super.call(this, APIService, ModelFactory, $q);
        this._ = _;
        this.Routes = Routes;
    }

    Services.WorkflowManager = Class(Services.BaseModelManager, {
        constructor: WorkflowManagerCtor,

        createWorkflow: function createWorkflow(company) {
            var url = this.Routes.v2_create_workflow_path(company._id);
            return this.apiCreate(url, null, company, true);
        },

        updateWorkflow: function updateWorkflow(company, workflow) {
            var url = this.Routes.v2_update_workflow_path(company._id, workflow._id);
            return this.apiUpdate(url, workflow, null, false);
        },

        updateWorkflowProjectType: function updateWorkflowProjectType(company, workflow) {
            var url = this.Routes.v2_update_workflow_project_type_path(company._id, workflow._id);
            return this.apiUpdate(url, workflow, null, false);
        },

        deleteWorkflow: function deleteWorkflow(company, workflowId) {
            var url = this.Routes.v2_delete_workflow_path(company._id, workflowId);
            return this.apiDelete(url).then(function success() {
               var index = this._.findIndex(company.workflows, function(workflow) {
                  return workflow._id === workflowId;
               });

               if (index !== -1) {
                   company.workflows.splice(index, 1);
               }

               return company;
            }.bind(this));
        },

        duplicateWorkflow: function duplicateWorkflow(company, workflowToDuplicate, newWorkflowTitle) {
            var url = this.Routes.v2_duplicate_workflow_path(company._id, workflowToDuplicate._id);
            return this.apiCreate(url, {save_as: newWorkflowTitle}, company, true);
        },

        getWorkflowTemplate: function getWorkflowTemplate(companyId, workflowId) {
            var url = this.Routes.v2_get_workflow_path(companyId, workflowId);
            return this.apiFetch(url, null, null, false);
        },

        getWorkflowInstance: function getWorkflowInstance(workspaceId) {
            var url = this.Routes.v2_get_workflow_for_workspace_path(workspaceId);
            return this.apiFetch(url).then(function(resp) {
                return resp.data.workflow;
            });
        },

        getWorkflowsForCompany: function getWorkflowsForCompany(company) {
            var url = this.Routes.v2_get_workflows_for_company_path(company._id);
            return this.apiFetch(url, null, company, true);
        },

        setWorkflowInstanceOnWorkspace: function setWorkflowInstanceOnWorkspace(workspace_id, workflow_id) {
            var url = this.Routes.v2_set_workflow_instance_path(workspace_id, workflow_id);
            return this.apiCreate(url, null, null, false);
        },

        removeWorkflowInstanceFromWorkspace: function removeWorkflowInstanceFromWorkspace(workspace_id, workflow_id) {
            var url = this.Routes.v2_unset_workflow_instance_path(workspace_id, workflow_id);
            return this.apiDelete(url, null, null, false);
        },

        changeWorkflowStepState: function changeWorkflowStepState(workspace_id, step_id, approval_status, subject, body, attachedFiles) {
            var data = {
                approval_status: approval_status,
                subject: subject,
                body: body,
                general_files: attachedFiles ? attachedFiles.generalFiles : [],
                image_files: attachedFiles ? attachedFiles.imageFiles : []
            };

            var url = this.Routes.v2_change_workflow_step_state_path(workspace_id, step_id);
            return this.apiUpdate(url, data, null, false);
        },
    });
}());

